/* eslint-disable no-mixed-spaces-and-tabs */
import { datetimeCovertertolocal } from '../../datetime-converter';
import { TASK_LIST, TASK_LIST_SUCCESS, TASK_LIST_ERROR, TASK_LIST_DETAILS, TASK_LIST_DETAILS_SUCCESS, TASK_LIST_DETAILS_ERROR, USERS_LIST, USERS_LIST_SUCCESS, USERS_LIST_ERROR } from './constants';

export default function shiftdata(state, action) {

	let tasks = [];
	let pagination = {};

	switch (action.type) {
      
	case TASK_LIST:
		return { ...state, pending: true };
                
	case TASK_LIST_SUCCESS:
                
		if (action.payload && action.payload.data && action.payload.data.length > 0) {
			if (action.payload) {
				pagination.total = action.payload.total ? action.payload.total : 0;
				pagination.limit = action.payload.limit ? action.payload.limit : 10;
				pagination.skip = action.payload.skip ? action.payload.skip : 0;
				pagination.current = action.page ? action.page : 1;
				pagination.pageSize =  action.pageSize ? action.pageSize : 10;
                    
			}
    
			action.payload.data.forEach((item) => {
				const startdate = datetimeCovertertolocal(item.assignedDate?item.assignedDate : '<Not Set>');
				const newstartdate = item.assignedDate ? (startdate.localdate + ' ' + startdate.localtime) : '<Not Set>';
        
				const enddate = datetimeCovertertolocal(item.endDate?item.endDate: '<Not Set>');
				const newenddate = item.endDate ? (enddate.localdate + ' ' + enddate.localtime) : '<Not Set>';
                    
				tasks.push({
					id : item?.id,
					name:item?.name?item.name:'No Data',
					assignedDate:newstartdate,
					endDate:newenddate,
					remarks:item?.remarks?item.remarks:'No Data',
					description:item?.description?item.description:'No Data',
					status:item.status?item.status:'No Data',
					attachmentUrls:item?.attachmentUrls,
					startassigndateUTC:item?.assignedDate,
					endtaskdateUTC:item?.endDate,
					userName : item?.users ? item?.users?.firstName + ' ' + item?.users?.lastName : 'No Data'
        
				});
			});
        
			return { ...state, tasks: tasks, pending: false, error: false , pagination: pagination  };
		} else {			
                
			if (action.payload && action.payload.data.length == 0) {
                        
				return { ...state, tasks: [], pending: false, error: false };
			} else {
    
				return { ...state, tasks: [] , pending: false, error: true };
			}
		}
                
	case TASK_LIST_ERROR:
		return { ...state, pending: false, error: true };

	case TASK_LIST_DETAILS:
		return { ...state, pending: true };
        
	case TASK_LIST_DETAILS_SUCCESS:
		return { ...state, pending: false, details:action.payload, error: false };
	case TASK_LIST_DETAILS_ERROR:
		return { ...state, pending: false, error: true };

	case USERS_LIST:
		return { ...state, pending: true };
	case USERS_LIST_SUCCESS:
		return { ...state, users_data: action.payload, pending: false };
	case USERS_LIST_ERROR:
		return { ...state, error: true, pending: false };
      
	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}